import { Model } from ".";

export default class ThirdPartyService extends Model {
	get singularNoun() {
		return "third party service";
	}

	resource() {
		return "third-party-services";
	}
}
